module.exports = __webpack_public_path__ + "img/clopotel-gri.64b3e6ea.svg";